import { render } from "./TreeAgenti.vue?vue&type=template&id=2fc8b32e&ts=true"
import script from "./TreeAgenti.vue?vue&type=script&lang=ts"
export * from "./TreeAgenti.vue?vue&type=script&lang=ts"

import "./TreeAgenti.vue?vue&type=style&index=0&id=2fc8b32e&lang=css"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__